import type { AreaFormData } from '../types';

export const AREA_FIELD_LABELS: Record<string, string> = {
	name: 'Nome',
	culture: 'Cultura',
	irrigation: 'Irrigação',
};

export const DEFAULT_AREA_FORM: AreaFormData = {
	name: '',
	culture: '',
	irrigation: '',
};
